import { render, staticRenderFns } from "./profileList.vue?vue&type=template&id=67a50490&"
import script from "./profileList.vue?vue&type=script&lang=js&"
export * from "./profileList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports